import React, { Component } from "react";

import "./colorSelector.css";

class colorSelector extends Component {
  render() {
    return (
      <div
        className={`colorSelector ${this.props.color} ${
          this.props.active === true ? "active" : ""
        }`}
        onClick={this.props.onClickHandler}
      >
        <div />
      </div>
    );
  }
}
export default colorSelector;
